









import { Component, Prop, Vue } from 'vue-property-decorator';

@Component
export default class Spinner extends Vue {
  
  @Prop({ default: '',  type: String}) label!: string;
  @Prop({ default: 'loading-label', type: String}) labelClass: string | undefined

}
